import { defineMessages } from 'react-intl';

export const scope = 'cb.containers.BrainTreePaymentsPage';

export default defineMessages({
  checkoutTitle: {
    id: `${scope}.checkoutTitle`,
    defaultMessage: 'Checkout',
  },
  checkoutSubtitle: {
    id: `${scope}.checkoutSubtitle`,
    defaultMessage: 'Securely complete your payment below.',
  },
  logoAlt: {
    id: `${scope}.logoAlt`,
    defaultMessage: 'logo',
  },
  savedCardsSectionLabel: {
    id: `${scope}.savedCardsSectionLabel`,
    defaultMessage: 'Saved Cards',
  },
  useNewCardButton: {
    id: `${scope}.useNewCardButton`,
    defaultMessage: '+ Use a different card',
  },
  backToSavedCardsButton: {
    id: `${scope}.backToSavedCardsButton`,
    defaultMessage: '← Back to saved cards',
  },
  saveCardLabel: {
    id: `${scope}.saveCardLabel`,
    defaultMessage: 'Securely save my card for future payments',
  },
  totalPriceLabel: {
    id: `${scope}.totalPriceLabel`,
    defaultMessage: 'Total Price',
  },
  payNowButton: {
    id: `${scope}.payNowButton`,
    defaultMessage: 'Pay Now',
  },
});